import { useAuth } from "../context/AuthContext";

/**
 * Hook personalizado que permite verificar si el usuario autenticado
 * posee un permiso específico definido en el JWT.
 *
 * @returns {function} hasPermission - Función que recibe una clave de permiso y devuelve true/false
 *
 * @example
 * const hasPermission = usePermission();
 * if (hasPermission("companies.create")) {
 *   // mostrar botón para crear empresa
 * }
 */
const usePermission = () => {
  const { user } = useAuth();

  /**
   * Verifica si el usuario tiene el permiso solicitado.
   * @param {string} permissionKey - Clave del permiso, por ejemplo: 'licenses.view'
   * @returns {boolean} - true si el usuario tiene el permiso, false en caso contrario
   */
  const hasPermission = (permissionKey) => {
    if (!user || !Array.isArray(user.permissions)) return false;
    return user.permissions.includes(permissionKey);
  };

  return hasPermission;
};

export default usePermission;
